<template>
    <div class="company-admin mb-3 mt-page">

        <b-row>
            <b-col>
                <h1> {{ $i18n.gt('HEADING_MANAGE_COMPANIES') }} </h1>
            </b-col>
            <b-col class="text-right">
                <router-link class="btn btn-ghost-blue mr-1"
                             :to="resellerId ? `/company/create/reseller/${resellerId}` : `/company/create`">
                    <shs-icon name="plus"></shs-icon>
                    New Company
                </router-link>
                <router-link class="btn btn-ghost-blue mr-1"
                             to="/practice/import">
                    <shs-icon name="plus"></shs-icon>
                    {{ $i18n.gt('BUTTON_IMPORT_PRACTICES') }}
                </router-link>
            </b-col>
        </b-row>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="false"
                    :get-items="getCompanies"
                    :filters="filters"
                    :fields="fields">

            <!-- template for custom columns -->
            <template v-slot:customField="slotProps">
                <div v-if="slotProps.row.field.key == 'actions'">
                    <router-link class="btn btn-secondary btn-sm mr-2 btn-icon"
                                 :to="resellerId ? `/resellerAdmin/${resellerId}/company/id/${slotProps.row.item.id}` : `/company/id/${slotProps.row.item.id}`">
                        <shs-icon name="pencil"></shs-icon>
                    </router-link>
                    <b-btn size="sm btn-icon"
                           variant="danger"
                           @click="deleteCompany(slotProps.row.item)">
                        <shs-icon name="delete"></shs-icon>
                    </b-btn>
                </div>
                <div v-else>
                    {{ slotProps.row.item[slotProps.row.field.key] }}
                </div>
            </template>

        </data-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Page to manage company admins
 */
export default Vue.extend({
    name: 'CompanyAdmin',
    props: {
        resellerId: Number
    },
    data() {
        return {
            fields: [
                {key: 'name', sortable: true},
                {key: 'contact_name', sortable: true, label: 'Contact Name'},
                {key: 'contact_email', sortable: true, label: 'Contact Email'},
                {key: 'actions', sortable: false, label: ''},
            ],
            filters: {
                name: {field: 'name', type: 'string', value: null, label: 'Company Name'},
            }
        }
    },
    methods: {
        getCompanies(listParams) {
            if (this.resellerId) {
                this.filters.reseller_id = {field: 'reseller_id', value: this.resellerId}
            }
            return this.$api.getItems(this, 'company', this.filters, listParams)
        },
        async deleteCompany(company) {
            if (await this.$bvModal.msgBoxConfirm(`Delete company ${company.name} permanently from the database? This will also delete all Plans for the company!`)) {
                try {
                    await this.$api.deleteItem(this, 'company', company)
                    this.$toasted.show('Company deleted', {duration: 3000})
                    this.$refs.dataTable.refresh();
                } catch (e) {
                    this.$utils.handleError(e, 'Error deleting company')
                }
            }
        },
    }
})

</script>
